<template>
  <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition">
    <v-card dark tile>
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Bild bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" text class="font-weight-bold" @click="save">
          <v-icon left>mdi-check</v-icon>
          Übernehmen
        </v-btn>
      </v-toolbar>

      <div id="tui-image-editor-container"></div>
    </v-card>
  </v-dialog>
</template>

<script>
// Importiere die Bibliothek und die CSS-Datei
import ImageEditor from "tui-image-editor"
import "tui-image-editor/dist/tui-image-editor.css"

// Deutsches Sprachpaket für die UI-Buttons
const locale_de = {
  // Hier könnten Übersetzungen stehen, für die Demo lassen wir es Englisch
  Crop: "Zuschneiden",
  Filter: "Filter",
  Text: "Text",
  // ... etc.
}

// Eigene Filter-Presets im Instagram-Stil
const customTheme = {
  "common.bi.image": "", // Firmenlogo entfernen
  "filter.grayscale.value": "grayscale(1)",
  "filter.sepia.value": "sepia(1)",
  "filter.vintage.value": "sepia(0.6) contrast(1.1) brightness(0.9)",
  "filter.clarity.value": "contrast(1.5) saturate(1.1)",
  "filter.warm.value": "sepia(0.4) saturate(1.2)",
}

export default {
  props: {
    value: { type: Boolean, default: false }, // Steuert die Sichtbarkeit des Dialogs
    imageFile: { type: File, default: null },
  },
  data() {
    return {
      dialog: this.value,
      imageEditorInstance: null,
    }
  },
  watch: {
    value(val) {
      this.dialog = val
      if (val && this.imageFile) {
        // Verzögere die Initialisierung, bis der Dialog vollständig gerendert ist
        this.$nextTick(() => {
          this.initImageEditor()
        })
      }
    },
    dialog(val) {
      if (!val) {
        this.$emit("input", false)
      }
    },
  },
  methods: {
    initImageEditor() {
      if (this.imageEditorInstance) {
        this.imageEditorInstance.destroy()
      }

      this.imageEditorInstance = new ImageEditor(document.querySelector("#tui-image-editor-container"), {
        includeUI: {
          loadImage: {
            path: URL.createObjectURL(this.imageFile),
            name: this.imageFile.name,
          },
          theme: customTheme,
          menu: ["text", "crop", "rotate", "draw", "icon"],
          initMenu: "filter",
          uiSize: {
            width: "100%",
            height: "calc(100vh - 56px)", // Füllt den verfügbaren Platz
          },
          menuBarPosition: "bottom",
        },
        cssMaxWidth: document.documentElement.clientWidth,
        cssMaxHeight: document.documentElement.clientHeight - 56,
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70,
        },
      })
      // Scrollen auf dem Handy deaktivieren, während der Editor offen ist
      document.body.style.overflow = "hidden"
    },
    cancel() {
      if (this.imageEditorInstance) {
        this.imageEditorInstance.destroy()
        this.imageEditorInstance = null
      }
      document.body.style.overflow = "auto"
      this.$emit("close")
    },
    closeWithoutReset() {
      if (this.imageEditorInstance) {
        this.imageEditorInstance.destroy()
        this.imageEditorInstance = null
      }
      document.body.style.overflow = "auto"
      this.$emit("closeWithoutReset")
    },
    save() {
      // Das bearbeitete Bild als Data-URL exportieren
      const dataURL = this.imageEditorInstance.toDataURL({ format: "jpeg", quality: 0.9 })

      // Data-URL in ein File/Blob-Objekt umwandeln für den Upload
      fetch(dataURL)
        .then((res) => res.blob())
        .then((blob) => {
          // Erstelle eine neue Datei aus dem Blob
          const editedFile = new File([blob], `edited-${this.imageFile.name}`, { type: "image/jpeg" })

          // Gib die bearbeitete Datei an die Parent-Komponente zurück
          this.$emit("save", editedFile)
          //this.cancel() // Editor schliessen
          this.closeWithoutReset() // Editor schliessen
        })
    },
  },
}
</script>

<style>
/* Überschreibe einige Standard-Styles des Editors für ein dunkles Theme */
.tui-image-editor-container {
  background-color: #1e1e1e;
  height: calc(100vh - 56px); /* v-toolbar Höhe abziehen */
}
.tui-image-editor-header-logo,
.tui-image-editor-help-menu,
.tui-image-editor-header {
  display: none !important; /* Werbung und Hilfemenü ausblenden */
}
.tui-image-editor-header-buttons button {
  background-color: #02734a !important;
  border-radius: 4px !important;
  color: white !important;
}
</style>
